// extracted by mini-css-extract-plugin
module.exports = {"experience":"styles_experience__FlC5N","locations":"styles_locations__HHYbw","column":"styles_column__cJLvg"};